import { LocalDate, LocalTime } from "@js-joda/core";
import React from "react";

export default function useTimeSlot() {
  const [selectedDate, setSelectedDate] = React.useState<LocalDate | null>(null);
  const [selectedTime, setSelectedTime] = React.useState<LocalTime | null>(null);
  const [shouldShowError, setShouldShowError] = React.useState(false);

  const selectedDateTime = React.useMemo(
    () =>
      selectedDate !== null && selectedTime !== null ? selectedDate.atTime(selectedTime) : null,
    [selectedDate, selectedTime]
  );

  const timeSlotAppCardRef = React.useRef<HTMLDivElement>(null);
  const selectDateLabelRef = React.useRef<HTMLDivElement>(null);
  const selectTimeLabelRef = React.useRef<HTMLDivElement>(null);

  const selectDate = (date: LocalDate) => {
    setSelectedDate(date);
    setSelectedTime(null);
    setShouldShowError(false);
  };

  const selectTime = (time: LocalTime) => {
    setSelectedTime(time);
    setShouldShowError(false);
  };

  const showError = () => setShouldShowError(true);

  return {
    selectedDate,
    selectedTime,
    selectedDateTime,
    shouldShowError,
    timeSlotAppCardRef,
    selectDateLabelRef,
    selectTimeLabelRef,
    selectDate,
    selectTime,
    showError,
  };
}
